var calculatorFurnitureAreaForm = document.querySelector('form[name="furniture-calculator-area"]')
var calculatorKitchenAreaForm = document.querySelector('form[name="kitchen-calculator-area"]')
var calculatorWallAreaForm = document.querySelector('form[name="wall-calculator-area"]')
var resetButton = document.querySelector('.calculator-area-result-button')

if (resetButton !== null) {
  resetButton.addEventListener("click", function(event){
    document.querySelector('.calculator-area-result').style.display = 'none';
    document.querySelector('.calculator-wrapper').style.display = 'block';
    if (calculatorFurnitureAreaForm !== null) {
      calculatorFurnitureAreaForm.reset()
    }
    if (calculatorKitchenAreaForm !== null) {
      calculatorKitchenAreaForm.reset()
    }
    if (calculatorWallAreaForm !== null) {
      calculatorWallAreaForm.reset()
    }
    const elements = document.querySelectorAll('.calculator__accordion');
    console.log(elements);
    elements.forEach(element => {
      const detailTag = element.querySelector("details");
      const summaryTag = element.querySelector("summary");
      summaryTag.setAttribute("aria-expanded", "false");
      detailTag.removeAttribute("open");
    });
  })
}

if (calculatorFurnitureAreaForm !== null) {
  calculatorFurnitureAreaForm.addEventListener("submit", function(event){
    event.preventDefault();
    document.querySelector('.calculator-area-result').style.display = 'none';
    const datas = new FormData(event.target);
    var furnitureHeight = datas.get('furnitureHeight');
    var furnitureWidth = datas.get('furnitureWidth');
    var furnitureDepht = datas.get('furnitureDepht');
    var surfaceToPaint = Math.round(((furnitureHeight * furnitureWidth) + (furnitureDepht * furnitureHeight * 2) + (furnitureDepht * furnitureWidth))*100)/100;
    var surfaceToPaint2 = surfaceToPaint * 2;
    var necessaryPaint = Math.round((surfaceToPaint * 1 / 12)*100)/100;
    var necessaryPaint2 = necessaryPaint * 2;
    document.getElementById('calculator-area-result-area-1').innerHTML = surfaceToPaint;
    document.getElementById('calculator-area-result-area-2').innerHTML = surfaceToPaint2;
    document.getElementById('calculator-area-result-area-3').innerHTML = necessaryPaint;
    document.getElementById('calculator-area-result-area-4').innerHTML = necessaryPaint2;
    document.querySelector('.calculator-area-result').style.display = 'block';
    document.querySelector('.calculator-wrapper').style.display = 'none';
  }, false);
}

if (calculatorKitchenAreaForm !== null) {
  calculatorKitchenAreaForm.addEventListener("submit", function(event){
    event.preventDefault();
    document.querySelector('.calculator-area-result').style.display = 'none';
    const datas = new FormData(event.target);
    var drawerNumber = datas.get('drawerNumber');
    var doorNumber = datas.get('doorNumber');
    var surfaceToPaint = Math.round(((drawerNumber * 0.6 * 0.4) + (doorNumber * 0.8 * 0.6))*100)/100;
    var surfaceToPaint2 = surfaceToPaint * 2;
    var necessaryPaint = Math.round((surfaceToPaint * 1 / 12)*100)/100;
    var necessaryPaint2 = necessaryPaint * 2;
    document.getElementById('calculator-area-result-area-1').innerHTML = surfaceToPaint;
    document.getElementById('calculator-area-result-area-2').innerHTML = surfaceToPaint2;
    document.getElementById('calculator-area-result-area-3').innerHTML = necessaryPaint;
    document.getElementById('calculator-area-result-area-4').innerHTML = necessaryPaint2;
    document.querySelector('.calculator-area-result').style.display = 'block';
    document.querySelector('.calculator-wrapper').style.display = 'none';
  }, false);
}

if (calculatorWallAreaForm !== null) {
  calculatorWallAreaForm.addEventListener("submit", function(event){
    event.preventDefault();
    document.querySelector('.calculator-area-result').style.display = 'none';
    const datas = new FormData(event.target);
    var wallWidth = datas.get('wallWidth');
    var wallHeight = datas.get('wallHeight');
    var windowNumber = datas.get('windowNumber');
    var wallDoorNumber = datas.get('wallDoorNumber');
    var surfaceToPaint = Math.round(((wallWidth * wallHeight) - (wallDoorNumber * 2) - (windowNumber * 1))*100)/100;
    var surfaceToPaint2 = surfaceToPaint * 2;
    var necessaryPaint = Math.round((surfaceToPaint * 1 / 10)*100)/100;
    var necessaryPaint2 = necessaryPaint * 2;
    document.getElementById('calculator-area-result-area-1').innerHTML = surfaceToPaint;
    document.getElementById('calculator-area-result-area-2').innerHTML = surfaceToPaint2;
    document.getElementById('calculator-area-result-area-3').innerHTML = necessaryPaint;
    document.getElementById('calculator-area-result-area-4').innerHTML = necessaryPaint2;
    document.querySelector('.calculator-area-result').style.display = 'block';
    document.querySelector('.calculator-wrapper').style.display = 'none';
  }, false);
}